<template>
  <div class="app-header1 header py-1 d-flex">
    <div class="container-fluid">
      <div class="d-flex">
        <div style="width:240px;background-color:#454646;">
          <img src="@/assets/images/zp-logo.gif"
               style="width: 100px;margin-left: 60px;margin-right: 60px;width: 120px;margin-top: 10px;margin-bottom:10px;">
        </div>
        <div style="width:calc(100% - 240px);background-color: #ffffff;box-shadow: 0px 5px 8px -5px #ccc">
            <span v-on:click="loadSites"
                style="position:relative;top:3px;padding: 2px 15px 2px 10px;color: #343434;border-radius: 5px;font-size: 12px;font-style: normal; cursor: pointer;margin-left: 30px;"
                v-html="siteName()">济南站</span>
        <a class="header-brand" style="color: white !important;">
        </a>
        <div class="d-flex order-lg-2 ml-auto header-right-icons header-search-icon">

          <div v-show="currentUserType=='personal' && !isHR" class="dropdown">
            <router-link to="/hr/apply_hr">
              <span
                style="color: white; border: 1px solid rgb(144, 195, 31);border-radius: 5px;padding: 2px 15px 2px 10px;position: relative;top: 5px;font-size: 12px;cursor: pointer;color:rgb(144, 195, 31) !important">HR身份认证</span>
            </router-link>
          </div>
          <div v-show="currentUserType=='personal'" class="dropdown" style="margin-left: 10px; ">
            <a v-on:click="initBBS()"><span
              style="color: #90c31f; border: 1px solid #90c31f;border-radius: 5px;padding: 2px 15px 2px 10px;position: relative;top: 5px;font-size: 12px;cursor: pointer;">H<span style="color:#f8b62b">i</span>turn知家</span></a>
          </div>

          <div class="dropdown">
            <a class="nav-link icon text-center" data-toggle="dropdown">
              <!-- <i class="icon icon-speech t7"></i> -->
              <img src="@/assets/images/header-icon-talk.png" style="width:20px;height:20px;">
              <span class=" nav-unread badge badge-info1 badge-pill t7" v-text="msgsTotal"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
              <a href="#" v-for="(item, index) in msgList" class="dropdown-item d-flex pb-3"
                 v-on:click="jumpPage(item.nextUrl, item.msgId)">
                <span class="avatar1 brround mr-3 align-self-center cover-image"></span>
                <div>
                  <span v-text="item.msg"></span>
                </div>
                <div class="dropdown-divider"></div>
              </a>

              <a href="#" class="dropdown-item d-flex pb-3"
                 v-on:click="jumpMsgHistory">
                <span class="avatar-history brround mr-3 align-self-center cover-image"></span>
                <div>
                  <span>历史消息</span>
                </div>
                <div class="dropdown-divider"></div>
              </a>
            </div>
          </div>

          <!-- <div v-show="currentUserType=='personal'" class="dropdown">
            <a class="nav-link icon full-screen-link nav-link-bg" v-on:click="handleFullScreen">
              <i class="fa fa-expand" id="fullscreen-button"></i>
            </a>
          </div> -->

          <div v-show="currentUserType=='personal'" class="dropdown text-center selector">
            <a class="nav-link leading-none white-link" data-toggle="dropdown">
              <!-- <i class="fa fa-user-o" style="font-size: 22px;"></i> -->

              <img src="@/assets/images/public/user2.png" style="width:25px;height:25px;border-radius:50px;" v-if="headUrl==''">
              <img :src="'/api/dfs/file/loadPic?id='+ headUrl" style="width:25px;height:25px;border-radius:50px;" v-if="headUrl!=''">
              <span>{{displayName==''?'未知':displayName}}</span>
              <img src="@/assets/images/icon-select-xl.png" style="width:10px;height:10px;">
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow " style="width:140px;min-width: 100px;">

              <a class="dropdown-item menu-link" v-on:click="updateTelephone" style="color:#999999 !important;">
                  <i class="dropdown-icon fa fa-phone"></i> 更换手机
              </a>
              <a class="dropdown-item menu-link" v-on:click="updatePassword" style="color:#999999 !important;">
                <i class="dropdown-icon fa fa-key"></i> 更改密码
              </a>
              <a class="dropdown-item" v-on:click="bindWx" style="color:#999999 !important;">
                <i class="dropdown-icon mdi  mdi-logout-variant"></i> 绑定微信
              </a>
              <a class="dropdown-item" v-on:click="handleLogout" style="color:#999999 !important;">
                <i class="dropdown-icon mdi  mdi-logout-variant"></i> 退出
              </a>
            </div>
          </div>

          <div v-show="currentUserType=='enterprise'" class="dropdown text-center selector">
            <a class="nav-link leading-none white-link" data-toggle="dropdown">
              <!-- <i class="fa fa-user-o" style="font-size: 22px;"></i> -->
              
              
              <img src="@/assets/images/public/user2.png" style="width:25px;height:25px;border-radius:50px;" v-if="headUrl==''">
              <img :src="'/api/dfs/file/loadPic?id='+ headUrl" style="width:25px;height:25px;border-radius:50px;" v-if="headUrl!=''">
              <span style="color:#666666;vertical-align: middle;">{{displayName==''?'未知':displayName}}</span>
              <img src="@/assets/images/public/icon-select-xl.png" style="width:10px;">
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow ">
              <a class="dropdown-item menu-link" v-on:click="updatePassword">
                <i class="dropdown-icon fa fa-key"></i> 更改密码
              </a>
              <a class="dropdown-item menu-link" v-on:click="updateTelephone">
                <i class="dropdown-icon fa fa-phone"></i> 更换手机
              </a>
              <a class="dropdown-item menu-link" v-on:click="handleLogout">
                <i class="dropdown-icon mdi  mdi-logout-variant"></i> 退出
              </a>
            </div>
          </div>
          <div v-show="currentUserType=='public'" class="dropdown">
            <a href="http://www.hiturnjob.com" class="nav-link icon">
              <span style="color: white;">登录</span>
            </a>
          </div>
        </div>
        </div>
          <!-- <span class="fa fa-bars" style="font-size:20px;position: relative;top: 5px;"
                v-on:click="handleSidebarCollapse"></span> -->
        
      </div>
    </div>
    <div id="siteModal" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content " style="min-height: 280px;">
          <div class="modal-body pd-20">
            <div style="text-align:center;color:#90c31f;"><span v-if="$lastSite!=null" >您上次登录站点为:{{$lastSite.appName}}</span></div>
            <h5 style="margin-top: 20px;text-align:center;color:#000000;" >站点列表</h5>
            <div style="margin-top: 10px;">
              <ul class="shandong-city">
                <li v-for="item in cities" :key="item.id" @click="changeCity(item.id)" :class="appDistrictCode==item.id?'city-item city-item-select':'city-item'">
                  <span>{{item.value}}</span>
                </li>
              </ul>
            </div>
            <h4 style="clear:both;border-bottom:1px solid #dddddd;padding-top:20px;padding-right:20px;"></h4>
            <div style="margin-top: 20px;">
                <ul class="site-block" v-if="parentApps.length>0">
                  <li v-for="(item,index,key) in parentApps" v-bind:key="item.id">
                    <span class="site-item" v-text="item.appName" v-on:click="changeSite(item)" :class="isAaiblable(item)"></span>
                  </li>
                </ul>
                <div v-if="parentApps.length==0" style="text-align:center;">
                  <img src="@/assets/images/nodata.png" style="height:60px;">
                  <h5 style="margin-top:20px;font-weight:300;">暂未开通，敬请期待</h5>
                </div>
                 <!--<div v-for="(item,index,key) in getParentApp()" v-bind:key="item.id" style="margin-top: 10px;">
                 <span class="site-item" v-text="item.appName" v-on:click="changeSite(item)"
                      :class="isAaiblable(item)"></span> : 
                  &nbsp;&nbsp;
                  
                  <span v-for="subItem in getSubApps(item.id)" class="site-item" v-text="subItem.appName" v-on:click="changeSite(subItem)" v-bind:key="subItem.id"
                      :class="isAaiblable(subItem)">
                  </span>
                </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getAppListAll} from '@/api/app'
    import {queryInterview} from '@/api/job'
    import {searchMyInvite} from '@/api/exam';
    import {getToken} from "@/utils/auth";
    import {getMyMsg, readMsg} from '@/api/msg'
    import {getMyCvList} from '@/api/cv'
    import {getEnterpriseInfo} from '@/api/enterprise'
    import Toastr from 'toastr2'
    import provice from '@/assets/data/data.js'
    import {getBusinessFilesInfos} from "@/api/common";
    export default {
        name: "Header",
        props: [],
        data() {
            return {
                sites: [],
                currentSite: this.$store.getters.site,
                isHR: this.$store.getters.isHR,
                msgNum: 2,
                interviewMsg: 2,
                testMsg: "您有2个测评邀请待处理",
                hashNewInterview: false,
                msgList: [],
                appDistrictCode:'',
                intervalId: 0,
                msgs: [],
                msgsTotal: "0",
                cities:[],
                provice:provice,
                parentApps:[],
                headUrl:'',
                displayName:''
            }
        },
        methods: {
            changeCity:function(id){
              this.appDistrictCode = id
              this.getParentApp()
            },
            getParentApp:function(){
              let parentApps = []
              const sites = this.sites
              for(let i=0;i<sites.length;i++){
                if(sites[i].appDistrictCode==this.appDistrictCode){
                  parentApps.push(sites[i])
                }
              }
              this.parentApps = parentApps
              //return parentApps
            },
            getSubApps:function(id){
              const sites = this.sites
              let subApps = []
              for(let i=0;i<sites.length;i++){
                if(id!=null && sites[i].appId == id){
                  subApps.push(sites[i])
                }
              }
              return subApps
            },
             getShanDongCity:function(){
              const shandong = '37'
              for(let i=0;i<this.provice.length;i++){
                if(this.provice[i].id == shandong){
                  const cities = this.provice[i].children
                  this.cities = cities
                  break
                }
              }
              this.appDistrictCode = this.cities[0].id
            },
            handleSidebarCollapse: function () {
                $('#sidebar').toggleClass('active');
                $('body').toggleClass('toggle');
            },
            isAaiblable: function (item) {
                if (item.available == 0) {
                      return 'site-item not-avaibale';
                }else{
                    if(item.id == this.currentSite.id){
                      return 'site-item site-item-select';
                    }
                }
            },
            siteName: function () {
                if (this.currentSite != null) {
                    return ' <i class="fa fa-map-marker" aria-hidden="true"></i> ' + this.currentSite.appName + '<span style="color:#999999">【切换站点】</span>'
                } else {
                    this.loadSites()
                }
            },
            enterpriseInfo: function () {
                this.$router.push({
                    path: '/enterprise/enterprise_detail'
                })
            },
            handleFullScreen: function () {
                if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
                    if (document.documentElement.requestFullScreen) {
                        document.documentElement.requestFullScreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullScreen) {
                        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                    } else if (document.documentElement.msRequestFullscreen) {
                        document.documentElement.msRequestFullscreen();
                    }
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                }
            },
            handleLogout: function () {
                this.$store.dispatch('user/userLogout')
            },
            bindWx: function () {
                this.$parent.openWxLoginModal()
            },
            changeUseType: function () {
                this.$store.dispatch('user/changeUserType')
            },
            loadSites: function () {
                getAppListAll({}).then(response => {
                    $("#siteModal").modal()
                    this.sites = response.apps
                    console.log(this.currentSite)
                    let currentCode = this.currentSite.appDistrictCode
                    if(currentCode==null){
                      for(let i=0;i<this.sites.length;i++){
                        const site = this.sites[i]
                        if(site.id == this.currentSite.id){
                          currentCode = site.appDistrictCode
                          this.$store.dispatch("app/changeSite", site)
                        }
                      }
                    }
                    this.changeCity(currentCode)
                }).catch(err => {
                    console.log(err)
                })
            },
            changeSite: function (item) {
                if (item.available == 1) {
                    this.$store.dispatch("app/changeSite", item)
                    this.currentSite = item
                    $("#siteModal").modal("hide")
                    window.location.href = "/index.html"
                } else {
                    $("#siteModal").modal('hide')
                    const toast = new Toastr()
                    toast.warning("站点未开通，敬请期待");
                }
            },
            initBBS: function (item) {
                window.location.href = "http://bbs.hiturnjob.com/index.html?token=" + getToken() + "&appType=0"
            },
            updatePassword: function () {
                $("#passwordModal").modal()
            },
            updateTelephone: function () {
                $("#telephoneModal").modal()
            },
            isPersonal() {
                let userType = this.$store.getters.userType
                if (userType == 'personal') {
                    return true
                }
                return false
            },
            jumpMsgHistory(){
                this.$router.push({
                    path: "/msg/index"
                })
            },
            getMyMsgs() {
                this.msgList = []
                var req = {}
                req['msgState'] = 0
                getMyMsg(req).then(response => {
                    this.msgs = response.result.data;
                    this.msgsTotal = response.result.amount + "";

                    if (response.result.amount > 10) {
                        this.msgsTotal = "9+"
                    }

                    this.msgs.forEach(m => {
                        var dt = {}
                        dt["msgId"] = m.msgId
                        dt["msg"] = m.msgContent
                        if (m.msgType == 0) {
                            dt["nextUrl"] = "/job/my_interview_list"
                        }

                        if (m.msgType == 1) {
                            dt["nextUrl"] = "/exam/my_exam_list"
                        }

                        if (m.msgType == 2) {
                            dt["nextUrl"] = "/exam/exam_invite_list/1"
                        }

                        if (m.msgType > 2) {
                            dt["nextUrl"] = "HRZJ"
                        }

                        this.msgList.push(dt)
                    })
                }).catch(error => {
                })
            },
            jumpPage(url, msgId) {
                readMsg(msgId).then(response => {
                        this.getMyMsgs();
                        if(url == "HRZJ"){
                            this.initBBS();
                        }else {
                            this.$router.push({
                                path: url
                            })
                        }

                    }
                )
            }
        },
        mounted() {
            this.msgList = [];
            this.getMyMsgs();
            this.getShanDongCity();
            this.intervalId = setInterval(() => {
                setTimeout(() => {
                    this.msgList = []
                    this.getMyMsgs()
                }, 0)
            }, 300000)
            const showSite = localStorage.getItem("showSiteDialog");
            if (showSite == "true") {
                this.loadSites()
                localStorage.removeItem("showSiteDialog")
            }

            if(this.$store.getters.userType=='personal'){
              getMyCvList().then(response => {
                if(response.cvList!=null && response.cvList.length>0){
                  const cvId = response.cvList[0].basicInfo.id
                  this.displayName = response.cvList[0].basicInfo.userName
                  getBusinessFilesInfos({moduleObjectId:cvId,uploadType:'1'}).then(response => {
                    let files = response.files
                    if(files!=null && files.length>0){
                      this.headUrl = files[0].id
                    }
                  })
                }
              })
            }
            if(this.$store.getters.userType=='enterprise'){
              const enterpriseId = this.$store.getters.enterpriseInfo.id
              
              this.displayName = this.$store.getters.enterpriseInfo.enterpriseName
              
              getBusinessFilesInfos({moduleObjectId:enterpriseId,uploadType:3}).then(response => {
                  let files = response.files
                    if(files!=null && files.length>0){
                      this.headUrl = files[0].id
                    }
              })
            }
            // this.openMessageJob();
        },
        computed: {
            currentUserType: {
                get: function () {
                    return this.$store.getters.userType
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.intervalId)
        }
    }
</script>

<style scoped>
.modal-body{
      padding: 1.68rem;
}
.header {
	padding-top: 0rem !important;
	padding-bottom: 0rem !important;
	/* border-bottom: 1px solid rgba(255,255,255,0.09); */
  border-bottom:none;
}

.header-search-icon{float: right;}

.container-fluid {
	width: 100%;
	padding-right: 0rem;
	padding-left:0rem;
	margin-right: auto;
	margin-left: auto;
}


  @media (max-width: 414px) {
    .menu-toggle-button {
      margin-top: 8px !important;
    }
  }

  .site-item {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    font-size: 12px;
    font-style: normal;
    padding: 2px 15px 2px 15px;
    margin-right: 15px;
    cursor: pointer;
  }

  .white-link {
    color: #ffffff !important;
  }

  .menu-toggle-button {
    margin-top: 12px;
    font-size: 20px;
    color: #fff;
  }

  .not-avaibale {
    background: #dddddd;
  }

  .nav-link {
    color: #ffffff;
  }

  .menu-link {
    color: #aaaaaa !important;
  }

  .menu-link:hover {
    color: #0d97de !important;
    cursor: pointer;
  }

  .t7 {
    top: 7px;
  }
.nav-link.icon i, .fa-user-o{
    color: #343434 !important;
}
  .badge-info1 {
    color: #fff;
    background: -webkit-gradient(linear, left top, right bottom, from(#ff7088), to(#ff7088)) !important;
    background: linear-gradient(to bottom right, #ff7088 0%, #ff7088 100%) !important;
  }

  .avatar1 {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    display: inline-block;
    background: #9ac043 no-repeat center/cover;
    position: relative;
    text-align: center;
    color: #fff;
    font-weight: 600;
    vertical-align: bottom;
    font-size: .875rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .shandong-city{
    list-style: none;
    display: inline;
  }
  .shandong-city .city-item{
    margin-left: 10px;
    margin-right: 10px;
    float: left;
    cursor: pointer;
  }
  .avatar-history {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    display: inline-block;
    background: grey no-repeat center/cover;
    position: relative;
    text-align: center;
    color: #fff;
    font-weight: 600;
    vertical-align: bottom;
    font-size: .875rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .site-block{
    display: inline;
  }
  .site-block li{
    float: left;
    margin-bottom:10px;
  }
  .city-item-select{
    font-weight: 500;
    color:#90c31f
  }
  .site-item-select{
    border: 1px solid #90c31f;
    background: #90c31f;
    color:#ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue